/* eslint-disable */

import React from 'react';
import Cookies from 'js-cookie';

const jwt_decode = require('jwt-decode');

const initPlugins = () => {
  if (typeof window !== 'undefined') {
    function gtag() {
      dataLayer.push(arguments);
    }
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || gtag;
    let logged_user_id = null;
    let squanchyUser = null;
    let logged_user_plan = 'VISITOR';
    try {
      squanchyUser = Cookies.get('squanchy')
        ? jwt_decode(Cookies.get('squanchy')).user
        : null;

      logged_user_plan = squanchyUser
        ? squanchyUser.subscription_plan
        : 'VISITOR';
      logged_user_id = squanchyUser ? squanchyUser.id : null;
    } catch (err) {
      logged_user_id = null;
      logged_user_plan = 'VISITOR';
    }

    // init GA
    let GAKEY = '';
    let GA4_KEY = '';
    let GTMKEY = '';
    const GaOptions = {};
    const GaOptionsGa4 = {};
    if (location.host === 'www.mashvisor.com') {
      GAKEY = 'UA-56828631-1';
      GA4_KEY = 'G-LN3DSNQBEN';
      GTMKEY = 'GTM-KHSJD9P';
    } else {
      GAKEY = 'UA-74769551-1';
      GA4_KEY = 'G-276SCRSXRN';
      GTMKEY = 'GTM-WG56V8G';
    }

    GaOptions.user_id = logged_user_id;
    GaOptions.userId = logged_user_id;
    GaOptions.dimension1 = logged_user_id;
    GaOptions.dimension2 = logged_user_id;
    GaOptions['&uid'] = logged_user_id;

    //GA4
    const userProperties = {
      dimension1: logged_user_id,
      dimension2: logged_user_id,
      user_id: logged_user_id,
      user_plan: logged_user_plan,
    };
    GaOptionsGa4.user_id = logged_user_id;
    GaOptionsGa4.userId = logged_user_id;
    GaOptionsGa4.user_properties = userProperties;

    window.gtag('js', new Date());
    window.gtag('config', GAKEY, GaOptions);
    window.gtag('config', GA4_KEY, GaOptionsGa4);
    window.gtag('set', 'user_properties', GaOptionsGa4.user_properties);

    window.dataLayer.push({ event: 'optimize.activate' });
    window.dataLayer.push({ event: 'adwords.activate' });
    let isGTMLoaded = false;
    function loadGTM() {
      if (isGTMLoaded) {
        return;
      }
      isGTMLoaded = true;
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js',
        });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', GTMKEY);
    }
    function loadGDPR() {
      (function (f) {
        function p(e, a, t) {
          var i = new Date();
          i.setTime(i.getTime() + t * 24 * 60 * 60 * 1e3);
          var r = 'expires='.concat(i.toUTCString(), ';'),
            o = 'domain=.mashvisor.com;';
          document.cookie = ''
            .concat(e, '=')
            .concat(a, ';')
            .concat(r)
            .concat(o, 'path=/');
        }
        function d(e) {
          var a = ''.concat(e, '='),
            t = decodeURIComponent(document.cookie),
            i = t.split(';'),
            r = null;
          return (
            i.find(function (o) {
              for (var n = o; n.charAt(0) === ' '; ) n = n.substring(1);
              return n.indexOf(a) === 0
                ? ((r = n.substring(a.length, n.length)), !0)
                : !1;
            }),
            r
          );
        }
        function s() {
          var e = [
              'asia/nicosia',
              'asia/famagusta',
              'atlantic/faroe',
              'america/danmarkshavn',
              'america/danmarkshavn',
              'america/godthab',
              'america/thule',
              'atlantic/reykjavik',
              'atlantic/azores',
              'atlantic/madeira',
              'africa/ceuta',
              'atlantic/canary',
              'utc',
            ],
            a = Intl.DateTimeFormat()
              .resolvedOptions()
              .timeZone.toLocaleLowerCase();
          return a.includes('europe') || e.includes(a);
        }
        function g() {
          return s() && d('cookie-consent') !== 'true';
        }
        function x() {
          p('cookie-consent', 'true', 180), l(), location.reload();
        }
        function v() {
          p('cookie-consent', 'false', 7), l();
        }
        function l() {
          var e = document.getElementById('GDPR_banner');
          document.body.removeChild(e);
        }
        var h = d('cookie-consent') === 'true',
          u = g() ? 'denied' : 'granted',
          c = GAKEY,
          k = GA4_KEY;
        window.dataLayer = window.dataLayer || [];
        function R() {
          window.dataLayer.unshift(arguments);
        }
        if (!D) {
          var e = function () {
              dataLayer.push(arguments);
            },
            D = e;
        }
        if (
          (R('consent', 'default', {
            ad_storage: u,
            analytics_storage: u,
            region: [
              'GR',
              'NL',
              'BE',
              'FR',
              'HU',
              'IT',
              'RO',
              'CH',
              'AT',
              'IM',
              'DK',
              'SE',
              'SJ',
              'PL',
              'DE',
              'FO',
              'GI',
              'LU',
              'IE',
              'IS',
              'AL',
              'MT',
              'CY',
              'AX',
              'BG',
              'LT',
              'LV',
              'EE',
              'MD',
              'BY',
              'AD',
              'MC',
              'SM',
              'VA',
              'UA',
              'RS',
              'ME',
              'XK',
              'HR',
              'SI',
              'BA',
              'MK',
              'CZ',
              'SK',
              'LI',
              'GB',
              'RU',
              'ES',
              'PT',
              'FI',
              'NO',
              'PS',
            ],
          }),
          d('cookie-consent') === null && s())
        ) {
          var e = function (t) {
              document.readyState === 'loading'
                ? document.addEventListener('DOMContentLoaded', t)
                : t();
            },
            a = function () {
              var t = document.createElement('div');
              t.id = 'GDPR_banner';
              var i = document.createElement('div'),
                r = document.createElement('div'),
                o = document.createElement('button'),
                n = document.createElement('button'),
                m = document.createElement('style');
              (r.innerHTML =
                "Mashvisor uses cookies to provide necessary site functionality and improve your experience. By browsing our website, you consent to our use of cookies. To learn more please refer to our <a class='GDPR_link' href='/cookie-policy'>cookie policy</a> "),
                (o.innerHTML = 'Accept'),
                (n.innerHTML = 'Reject'),
                o.addEventListener('click', x),
                n.addEventListener('click', v),
                i.appendChild(o),
                i.appendChild(n),
                t.appendChild(r),
                t.appendChild(i),
                t.classList.add('GDPR_banner_container'),
                r.classList.add('GDPR_text'),
                i.classList.add('GDPR_buttons'),
                o.classList.add('GDPR_accept'),
                n.classList.add('GDPR_reject'),
                (m.innerHTML =
                  '.GDPR_banner_container{width:100%;min-height:50px;position:fixed;bottom:0;left:0;display:flex!important;justify-content:space-between;align-items:baseline;background-color:#414562!important;color:#fff!important;flex-wrap:wrap;z-index:999;font-family:Lato,proximanovaRegular,sans-serif!important;line-height:1.428571429!important;font-size:16px}.GDPR_link{color:#009ee2}.GDPR_text{margin:15px;margin-top:auto!important;margin-bottom:auto!important;flex:1 0 300px;display:inline-block}.GDPR_buttons{margin-top:auto!important;margin-bottom:auto!important;padding-right:80px;display:inline-block}.GDPR_accept{background-color:#009ee2;padding:5px 10px;margin:15px;border:none;cursor:pointer;border-radius:3px;font-size:16px!important;color:#fff!important;float:left;z-index:3147483003}.GDPR_accept:hover{background-color:#1a74aa}.GDPR_reject{background:none;text-decoration:underline;padding:5px 10px;margin:15px;border:none;cursor:pointer;font-size:16px!important;color:#fff}.GDPR_reject:hover{color:#fff;background-color:#ff5861cc;border-radius:3px}@media screen and (max-width: 1300px){.GDPR_accept,.GDPR_reject{font-size:14px!important}.GDPR_contentStyle{padding-top:5px;padding-bottom:5px}.GDPR_text{text-align:center;font-size:14px;padding-top:10px;padding-bottom:10px}}@media screen and (max-width: 590px){.GDPR_text{padding-right:45px;padding-left:45px;padding-top:5px}.GDPR_buttons{margin-right:auto;margin-left:auto;padding-left:80px}}@media screen and (max-width: 560px){.GDPR_text{padding-right:50px;padding-left:50px}}@media screen and (max-width: 460px){.GDPR_text{padding:5px 0;flex:auto}.GDPR_buttons{padding:0;padding-bottom:15px!important}}'),
                document.head.appendChild(m),
                document.body.appendChild(t);
            },
            G = e,
            P = a;
          e(a);
        } else
          k &&
            (function (e, a, t, i, r, o, n) {
              (o = a.createElement(t)),
                (n = a.getElementsByTagName(t)[0]),
                (o.async = 1),
                (o.src = i),
                n.parentNode.insertBefore(o, n);
            })(
              window,
              document,
              'script',
              'https://www.googletagmanager.com/gtag/js?id=' + k,
            );
        var b = { isBlocked: g(), isEuropean: s() };
        f.mvGDPR = b;
      })(window);
    }
    let scriptInjection = function () {
      /**
       * sumome short code
       */
      const pathname = window.location.pathname;
      const disableSumo = pathname === '/' || pathname === '/home/';

      if (!disableSumo) {
        if (typeof sumo === 'undefined') {
          (function (s, u, m, o, j, v) {
            j = u.createElement(m);
            v = u.getElementsByTagName(m)[0];
            j.async = 1;
            j.src = o;
            j.dataset.sumoSiteId =
              'f5e978d6922578a52d8d8fd748cb333dd5c2a529f962eab82eea22a26928d8da';
            v.parentNode.insertBefore(j, v);
          })(window, document, 'script', '//load.sumo.com/');
        }
      }

      /**
       * intercome short code
       */
      let intercomSettings = null;
      (function () {
        var w = window;
        var ic = w.Intercom;
        if (typeof ic === 'function') {
          ic('reattach_activator');
          ic('update', intercomSettings);
        } else {
          var d = document;
          var i = function () {
            i.c(arguments);
          };
          i.q = [];
          i.c = function (args) {
            i.q.push(args);
          };
          w.Intercom = i;
          function l() {
            var s = d.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://widget.intercom.io/widget/o8bzwj24';
            var x = d.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
          }
          l();
        }
      })();
      if (logged_user_id) {
        window.intercomSettings = {
          app_id: 'o8bzwj24',
          user_id: logged_user_id,
        };
      } else {
        window.intercomSettings = {
          app_id: 'o8bzwj24',
        };
      }

      /**
       * calendly script injection
       */
      var calendlyStyle = document.createElement('link');
      calendlyStyle.rel = 'stylesheet';
      calendlyStyle.href =
        'https://assets.calendly.com/assets/external/widget.css';
      document.body.appendChild(calendlyStyle);
      let calendlyScript = document.createElement('script');
      calendlyScript.type = 'text/javascript';
      calendlyScript.src = 'https://calendly.com/assets/external/widget.js';
      document.body.appendChild(calendlyScript);
      /**
       * hubsport demo booking
       */
      let hubspotDemo = document.createElement('script');
      hubspotDemo.type = 'text/javascript';
      hubspotDemo.src =
        'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
      document.body.appendChild(hubspotDemo);

      // Google Tag Manager
      loadGTM();
    };

    var scriptInjectionWithIdleCb = function () {
      window.removeEventListener('mousemove', scriptInjectionWithIdleCb);
      window.removeEventListener('scroll', scriptInjectionWithIdleCb);
      window.removeEventListener('touchstart', scriptInjectionWithIdleCb);
      requestIdleCallback(scriptInjection);
    };
    var loadScriptsOnInteraction = function () {
      window.addEventListener('mousemove', scriptInjectionWithIdleCb);
      window.addEventListener('scroll', scriptInjectionWithIdleCb);
      window.addEventListener('touchstart', scriptInjectionWithIdleCb);
    };
    window.requestIdleCallback =
      (typeof self !== 'undefined' &&
        self.requestIdleCallback &&
        self.requestIdleCallback.bind(window)) ||
      function requestIdleCallback(cb) {
        var start = Date.now();
        return setTimeout(function () {
          cb({
            didTimeout: false,
            timeRemaining() {
              return Math.max(0, 50 - (Date.now() - start));
            },
          });
        }, 1);
      };

    if (document.readyState === 'complete') {
      loadScriptsOnInteraction();
    } else {
      window.addEventListener('load', loadScriptsOnInteraction);
    }
    // load GTM if affiliate link
    function getParameterByName(name, url = window.location.href) {
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
    // ref=> tap
    if (!!getParameterByName('ref') || getParameterByName('source') === 'aw') {
      loadGTM();
    }
    loadGDPR();
  }
};

class PluginsLoader extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    initPlugins();
  }

  render() {
    return <></>;
  }
}

export default PluginsLoader;
